import { createRoot } from "react-dom/client";
import App from "./App";
import 'react-toastify/dist/ReactToastify.css';
import "./App.css";

createRoot(document.getElementById("root")!).render(
  <>
    <App />
  </>
);
